module.exports = __webpack_public_path__ + "static/media/easter.0985cb04.png";